import {styled} from "@mui/material/styles"

export const LoadMoreButtonContainer = styled("div")(() => ({
    flex: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "2rem",
    gap: "0.6rem",
}))

export const LoadMoreButtonInnerContainer = styled("div")(() => ({
    width: "18.75rem",
}))
